import { render } from "./CommandeEdit.vue?vue&type=template&id=2d35bfc8"
import script from "./CommandeEdit.vue?vue&type=script&lang=js"
export * from "./CommandeEdit.vue?vue&type=script&lang=js"

import "./CommandeEdit.vue?vue&type=style&index=0&id=2d35bfc8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__